import dayjs from 'dayjs';
import { useCallback, useEffect } from 'react';

import { useViewContext } from '../../context/view-context';

import AppTimeRangePicker from './app-time-range-picker';

import { TimeRanges, TimeSelection } from '@controlrooms/models';
import { getQueryParams } from '@controlrooms/utils';

const ViewsTimeRangePicker = () => {
  const { viewState, updateTimeSelection, recordTimelineHistory } = useViewContext();

  // Set the time selection from query params.
  const { startTime: qpStartTime, endTime: qpEndTime } = getQueryParams(location.search);

  useEffect(() => {
    if (qpStartTime && qpEndTime) {
      updateTimeSelection({
        startTime: dayjs(qpStartTime),
        endTime: dayjs(qpEndTime),
        timezone: viewState.timeSelection?.timezone,
        timeRange: TimeRanges.CUSTOM,
        streamingTimeInSeconds: 0,
        nowSelected: false,
      });
    }
  }, [qpEndTime, qpStartTime, viewState.timeSelection?.timezone, updateTimeSelection]);

  const handleApply = useCallback(
    (timeSelection: TimeSelection, updateHistory = true) => {
      if (updateHistory) recordTimelineHistory();
      updateTimeSelection(timeSelection, updateHistory);
    },
    [recordTimelineHistory, updateTimeSelection],
  );

  return (
    <AppTimeRangePicker
      value={viewState.timeSelection}
      onApply={handleApply}
      title="Select Timeframe"
      showDuration={true}
      showTimezone={true}
      allowTimezoneChange={true}
    />
  );
};

export default ViewsTimeRangePicker;
